import {
  BaseIdCodeQuery,
  ClassificatorQuery,
  ClassificatorValueQuery,
  LanguageQuery,
  PropertyQuery,
  UnitQuery,
  UserQuery
} from "common-shared";
import {plainToInstance} from "class-transformer";
import {CostPriceComponentQuery, ItemQuery, ManufacturingItemSaveModel} from "web-shared";
import {ResourceQuery} from "../manufacturing/resources/models/resource.query";

export function convertToClassObjects(storeName: string, state: any): any {
  let entityClass: any;
  switch (storeName) {
    case 'unit': {
      entityClass = UnitQuery;
      break;
    }
    case 'language': {
      entityClass = LanguageQuery;
      break;
    }
    case 'user': {
      entityClass = UserQuery;
      break;
    }
    case 'property': {
      entityClass = PropertyQuery;
      break;
    }
    case 'ClassificatorValue': {
      entityClass = ClassificatorValueQuery;
      break;
    }
    case 'CostPriceComponent': {
      entityClass = CostPriceComponentQuery;
      break;
    }
    case 'Classificator': {
      entityClass = ClassificatorQuery;
      break;
    }
    case 'Item': {
      entityClass = ItemQuery;
      break;
    }
    case 'resource': {
      entityClass = ResourceQuery;
      break;
    }
    case 'item-auto-save': {
      entityClass = ManufacturingItemSaveModel;
      break;
    }
    default:
      entityClass = BaseIdCodeQuery;
  }

  Object.keys(state.entities).map(key => state.entities[key] = plainToInstance(entityClass, state.entities[key]));

  return state;
}


